import Lonely from "../components/CheckoutSteps/Lonely";

function NoMatch() {
  return <Lonely />;
}

export default NoMatch;
